import { IconSmartbearLogo } from '@smartbear/swagger-portal-component-library'
import { useTranslation } from 'react-i18next'

export const BrandingBar = () => {

  const { t } = useTranslation()

  return (
    <div className="mt-[80px]">
      <div
        className="sp-branding-bar flex items-center fixed px-4 inset-x-0 bottom-0 h-[80px] border-t bg-neutral-80 dark:bg-neutral-95 border-t-neutral-30 dark:border-t-neutral-80 w-full z-50"
        data-testid="bottom-branding-bar"
      >
        <div className="flex items-center">
          <span className="mr-2 text-neutral-20 dark:text-neutral-40 text-body2">{t('consumer.branding.logoText')}</span>
          <span className="text-neutral-10 dark:text-neutral-05"><IconSmartbearLogo /></span>
        </div>
      </div>
    </div>
  )
}